import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';

import './loadingCards.scss';

export const EVENT_TYPE = 'event';
export const ORGANIZER_TYPE = 'organizer';
export const ORGANIZER_ARTICLE_TYPE = 'organizerArticle';

const EventLoadingCard = () => (
    <div className="consumer-event-loading-card">
        <div className="consumer-event-loading-card__item consumer-event-loading-card__main" />
        <div className="consumer-event-loading-card__aside">
            <div className="consumer-event-loading-card__item" />
            <div className="consumer-event-loading-card__item" />
            <div className="consumer-event-loading-card__item" />
            <div className="consumer-event-loading-card__item" />
        </div>
    </div>
);

const OrganizerLoadingCard = () => (
    <div className="consumer-org-loading-card">
        <div className="consumer-org-loading-card__item consumer-org-loading-card__main" />
        <div className="consumer-org-loading-card__aside">
            <div className="consumer-org-loading-card__item" />
            <div className="consumer-org-loading-card__item" />
            <div className="consumer-org-loading-card__item" />
            <div className="consumer-org-loading-card__item" />
        </div>
    </div>
);

const OrganizerArticleLoadingCard = () => (
    <div className="consumer-org-article-loading-card">
        <div className="consumer-org-article-loading-card__header">
            <div className="consumer-org-article-loading-card__header-title" />
            <div className="consumer-org-article-loading-card__header-description--large" />
            <div className="consumer-org-article-loading-card__header-description--small" />
        </div>
        <div className="consumer-org-article-loading-card__background">
            <div className="consumer-org-article-loading-card__summary">
                <div className="consumer-org-article-loading-card__summary-org-info">
                    <div className="consumer-org-article-loading-card__summary-org-image" />
                    <div className="consumer-org-article-loading-card__summary-org-text-container">
                        <div className="consumer-org-article-loading-card__summary-org-title" />
                        <div className="consumer-org-article-loading-card__summary-org-subtitle" />
                    </div>
                </div>
                <div className="consumer-org-article-loading-card__summary-title--large" />
                <div className="consumer-org-article-loading-card__summary-title--small" />
                <div className="consumer-org-article-loading-card__summary-description--large" />
                <div className="consumer-org-article-loading-card__summary-description--small" />
                <div className="consumer-org-article-loading-card__summary-cta" />
            </div>
        </div>
    </div>
);

const _getDeclaredCards = (cardCount, type) =>
    times(cardCount, (index) => {
        let loadingCard = (
            <EventLoadingCard key={`consumer-event-loading-card-${index}`} />
        );

        if (type === ORGANIZER_TYPE) {
            loadingCard = (
                <OrganizerLoadingCard
                    key={`consumer-organizer-loading-card-${index}`}
                />
            );
        }

        if (type === ORGANIZER_ARTICLE_TYPE) {
            loadingCard = (
                <OrganizerArticleLoadingCard
                    key={`consumer-org-article-loading-card-${index}`}
                />
            );
        }

        return loadingCard;
    });

/*
 * Rough implementation of a configurable loading state component for
 * event style cards on search experiences. Currently structured to support
 * a single column of cards of variable counts and styles.
 */
export default class LoadingCards extends PureComponent {
    static propTypes = {
        /*
         * Determines loading card style to display
         * list, grid, list-square
         */
        style: PropTypes.oneOf(['list', 'grid', 'list-square']),
        /*
         * The number of cards to be rendered
         */
        cardCount: PropTypes.number,

        /*
         * Determines loading card type to render
         * event, organizer
         */
        type: PropTypes.oneOf([
            EVENT_TYPE,
            ORGANIZER_TYPE,
            ORGANIZER_ARTICLE_TYPE,
        ]),
    };

    static defaultProps = {
        style: 'list',
        type: EVENT_TYPE,
        cardCount: 5,
    };

    render() {
        const { style, cardCount, type } = this.props;

        const cards = _getDeclaredCards(cardCount, type);

        return (
            <section
                className={`consumer-loading-cards__container consumer-loading-cards--${style} eds-l-pad-top-6 eds-l-pad-hor-6`}
            >
                {cards}
            </section>
        );
    }
}
